/* Japan Card Collect — fiche produit Shopify (adapté de card.js du prototype).
   Données produit inlinées par Liquid dans window.JCC_PRODUCT ; panier réel /cart/add.js. */
(function () {
  "use strict";
  const P = window.JCC_PRODUCT;
  if (!P) return;
  const I18N = window.I18N || { fr: {}, en: {} };
  const $ = (id) => document.getElementById(id);
  const lang = () => ((document.documentElement.lang || "fr") === "en" ? "en" : "fr");
  const t = (k) => (I18N[lang()] && I18N[lang()][k]) || (I18N.fr && I18N.fr[k]) || "";
/* Devise : NE PAS coder « € » en dur. Avec Shopify Markets et les devises locales, les prix
   Liquid arrivent déjà CONVERTIS dans la devise du visiteur : un client polonais recevait 859
   (zloty) affichés « 859,00 € », soit 4,4x le vrai prix de la carte. On formate donc avec la
   devise active, en gardant les conventions typographiques de la langue. */
  const DEVISE = (window.Shopify && Shopify.currency && Shopify.currency.active) || "EUR";
  const fmtMoney = (n) => { try { return new Intl.NumberFormat(lang() === "en" ? "en-GB" : "fr-FR",
      { style: "currency", currency: DEVISE }).format(n); }
    catch (e) { return (lang() === "en" ? "" : "") + n.toFixed(2) + " " + DEVISE; } };
  const money = (p) => fmtMoney((+p));
  const esc = (s) => String(s == null ? "" : s).replace(/[&<>"]/g, (m) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[m]));
  const RSTAR = '<svg class="rstar rstar--sm" viewBox="0 0 24 24" aria-hidden="true">' +
    '<path d="M12 1.8l3.1 6.3 6.9.9-5 4.8 1.2 6.9-6.2-3.3-6.2 3.3 1.2-6.9-5-4.8 6.9-.9z" ' +
    'fill="url(#gstar)" stroke="#15151e" stroke-width="1.7" stroke-linejoin="round"/></svg>';
  const CONDS = ["MT", "NM", "EX", "GD", "LP", "PL", "PO"];

  const name = () => (lang() === "en" ? P.en : P.fr) || P.fr || P.en;
  /* Règle boutique : un état épuisé ne doit apparaître NULLE PART. On travaille donc sur les
     seules variantes encore en stock ; P.variants reste la liste complète (retrouver une variante
     par id, prix de référence des rails). Si tout est vendu, on retombe sur la 1re variante pour
     que la fiche s'affiche quand même (le bandeau « épuisé » prend le relais). */
  const inStock = P.variants.filter((v) => v.qty > 0);
  const multi = !P.hasOnlyDefault && inStock.length > 1;
  let sel = inStock[0] || P.variants[0];
  let qty = 1;
  const totalStock = () => P.variants.reduce((a, v) => a + Math.max(0, v.qty), 0);
  let ppFilter = null;   // posé par la galerie : filtre les photos selon l'état sélectionné

  /* ---------- prix / stock / quantité ---------- */
  function renderPriceStock() {
    $("ppPrice").textContent = money(sel.price);
    const st = $("ppStock");
    const avail = Math.max(0, sel.qty);
    if (totalStock() === 0) {
      st.className = "pp-stockpill pp-stockpill--out";
      st.textContent = "● " + t("pp_stock_out");
      $("ppActions").hidden = true;
      $("ppNotify").hidden = false;
    } else {
      const tier = avail >= 5 ? "in" : avail >= 3 ? "mid" : "low";
      st.className = "pp-stockpill pp-stockpill--" + tier;
      st.textContent = "● " + t("pp_stock_in") + " · " + avail + " " +
        (avail === 1 ? t("pp_stock_left_one") : t("pp_stock_left")) +
        (avail === 1 ? " — " + t("pp_stock_one") : "");
      $("ppActions").hidden = false;
      $("ppNotify").hidden = true;
    }
    qty = Math.max(1, Math.min(qty, avail || 1));
    $("qtyInput").value = qty;
    $("qtyInput").max = String(Math.max(1, avail));
    $("ppAddPrice").textContent = "· " + money(sel.price * qty);
    const sp = $("ppStickyPrice");
    if (sp) sp.textContent = money(sel.price);
    if (window.JCC_SYNC_STICKY) window.JCC_SYNC_STICKY();
    $("ppAdd").disabled = avail === 0;
  }

  /* ---------- état(s) ---------- */
  /* État d'une variante : son titre (« EX », « GD »…). Sur un produit à variante unique, le titre
     Shopify est « Default Title » → on prend le métachamp. Ne jamais utiliser P.cond quand la
     variante porte un titre : il décrit la carte à l'import et peut viser un exemplaire vendu. */
  function condOf(v) { return P.hasOnlyDefault ? (P.cond || null) : ((v && v.title) || P.cond || null); }
  function renderConds() {
    const block = $("ppCondBlock");
    if (!block) return;
    const anyCond = multi || P.cond || P.gradeNote;
    block.hidden = !anyCond;
    if (!anyCond) return;
    if (P.gradeNote) {
      $("ppChips").innerHTML =
        '<span class="pp-chip is-active"><span class="pp-chip__top">' +
        '<span class="cond-ico cond-ico--mt">' + esc(P.gradeCo) + "</span><b>" +
        esc(P.gradeCo + " " + P.gradeNote) + "</b></span></span>";
      return;
    }
    const items = multi ? inStock : [{ id: sel.id, title: condOf(sel), price: sel.price, qty: sel.qty }];
    $("ppChips").innerHTML = items.map((v) => {
      const k = (condOf(v) || "NM").toUpperCase();
      const off = multi && v.qty <= 0;
      return '<button type="button" class="pp-chip' + (sel.id === v.id || !multi ? " is-active" : "") +
        (off ? " is-off" : "") + '" data-vid="' + v.id + '" ' + (off ? "disabled" : "") +
        ' title="' + esc(t("cond_" + k.toLowerCase() + "_d")) + '">' +
        '<span class="pp-chip__top"><span class="cond-ico cond-ico--' + k.toLowerCase() + '">' + k + "</span>" +
        "<b>" + (t("cond_" + k.toLowerCase()) || k) + (multi ? " · " + money(v.price) : "") + "</b></span></button>";
    }).join("");
    if (multi) {
      $("ppChips").querySelectorAll("[data-vid]").forEach((b) => {
        b.addEventListener("click", () => {
          const v = P.variants.find((x) => String(x.id) === b.dataset.vid);
          if (!v || v.qty <= 0) return;
          sel = v; qty = 1;
          if (ppFilter) ppFilter(condOf(v));
          renderConds(); renderPriceStock(); renderDescSpecs();
        });
      });
    }
  }

  /* ---------- description / specs / guide ---------- */
  function fillTpl(key) {
    return t(key)
      .replace(/\{name\}/g, name())
      .replace(/\{set\}/g, P.setName)
      .replace(/\{code\}/g, P.code)
      .replace(/\{num\}/g, P.ref)
      .replace(/\{rar\}/g, P.rarity)
      .replace(/\{era\}/g, (P.eraKey && t(P.eraKey)) || P.setName);
  }
  function renderDescSpecs() {
    const d = ["pp_d1", "pp_d2", "pp_d3"].map((k) => "<p>" + esc(fillTpl(k)) + "</p>").join("");
    if (d.replace(/<[^>]+>/g, "").trim()) $("ppDesc").innerHTML = d;
    /* L'état affiché dans les caractéristiques suit la puce sélectionnée : sur une carte
       proposée en plusieurs états, P.cond ne décrit qu'un exemplaire (parfois déjà vendu). */
    const cSel = condOf(sel);
    const condLabel = P.gradeNote ? P.gradeCo + " " + P.gradeNote
      : (cSel ? (t("cond_" + cSel.toLowerCase()) || cSel) + " (" + cSel + ")" : "—");
    const rows = [
      ["pp_spec_set", P.setName], ["pp_spec_code", P.code],
      ["pp_spec_num", P.ref], ["pp_spec_rar", P.rarity || "—"],
      ["pp_spec_lang", t("pp_spec_lang_v")],
      ["pp_spec_era", (P.eraKey && t(P.eraKey)) || "—"], ["pp_spec_cond", condLabel],
    ];
    $("ppSpecs").innerHTML = rows.map((r) => "<tr><td>" + t(r[0]) + "</td><td>" + esc(r[1]) + "</td></tr>").join("");
  }
  function renderGuide() {
    $("ppGuideGrid").innerHTML = CONDS.map((k) =>
      '<details class="pp-gacc"><summary><span class="cond-ico cond-ico--' + k.toLowerCase() + '">' + k + "</span>" +
      "<b>" + t("cond_" + k.toLowerCase()) + "</b></summary>" +
      "<p>" + t("cond_" + k.toLowerCase() + "_d") + "</p></details>").join("");
  }

  /* ---------- rails ---------- */
  function railCard(c) {
    const nm2 = (lang() === "en" ? c.nameEn : c.name) || c.name;
    const out = !c.stock;
    return '<article class="ccard ccard--go" data-href="/products/' + c.handle + '" data-handle="' + c.handle + '">' +
      '<div class="ccard__media">' + (c.rarity ? '<span class="rar rar--' + c.rarity + '">' + c.rarity + "</span>" : "") +
      '<img class="ccard__wm" src="' + window.JCC.base + 'logo.png" alt="" />' +
      '<div class="ccard__cardwrap"><img class="ccard__scan" src="' + esc(c.img) + '" alt="' + esc(nm2) + '" loading="lazy" /></div></div>' +
      '<div class="ccard__info"><span class="ccard__name">' + esc(nm2) + "</span>" +
      '<span class="ccard__series">' + esc(c.code || P.code) + " · " + c.n + "</span>" +
      '<div class="ccard__foot"><span class="price">' + money(c.price) + "</span>" +
      '<button class="btn btn--dark ccard__add" type="button"' + (out ? " disabled" : "") + ">" + t("set_add") + "</button></div></div></article>";
  }
  /* ---------- rails : UNIQUEMENT des cartes EN STOCK ----------
     « Même série » : cartes de la série en stock (ordre numéro) ; si < 3,
     bascule « À découvrir aussi » (même ère puis prix proche, en stock).
     « Même Pokémon » : même espèce en stock ; sinon complément en stock.
     Dédup entre rails ; images = vraies images produit via /products/{h}.js. */
  let _si = null;
  function loadSI() {
    if (_si) return Promise.resolve(_si);
    return fetch(window.JCC.data.searchIndex).then((r) => r.json()).then((si) => { _si = si; return si; });
  }
  const railData = { related: null, relatedFallback: false, same: null, sameIsSpecies: false };
  /* handle = celui fourni par l'index (v2) ; repli {code}-{n} pour un index v1 encore en cache. */
  const tupleToItem = (a) => ({ code: a[0], handle: a[9] || a[0].toLowerCase() + "-" + a[1], n: a[1],
    name: a[2], nameEn: a[3], rarity: a[4], price: a[5], stock: a[6] });
  function withImages(items, want) {
    return Promise.all(items.slice(0, want + 4).map((c) =>
      fetch("/products/" + c.handle + ".js")
        .then((r) => (r.ok ? r.json() : null)).catch(() => null)
        .then((pr) => (pr && pr.featured_image ? Object.assign({ img: pr.featured_image }, c) : null))
    )).then((list) => list.filter(Boolean).slice(0, want));
  }
  async function buildRails() {
    let si = null;
    try { si = await loadSI(); } catch (e) { return; }
    if (!si || !si.cards) return;
    const eraMap = {};
    (si.sets || []).forEach((sx) => { eraMap[sx[0]] = sx[2]; });
    const myEra = eraMap[P.code];
    const basePrice = (sel || P.variants[0] || {}).price || 0;
    const notMe = (a) => !(a[0] === P.code && a[1] === P.n);
    const byEraThenPrice = (x, y) =>
      ((eraMap[y.code] === myEra) - (eraMap[x.code] === myEra)) ||
      (Math.abs(x.price - basePrice) - Math.abs(y.price - basePrice));
    const shown = new Set([P.handle]);

    /* rail 1 — même série */
    let rel = si.cards.filter((a) => a[0] === P.code && notMe(a) && a[6] > 0)
      .map(tupleToItem).sort((x, y) => x.n - y.n);
    railData.relatedFallback = rel.length < 3;
    if (railData.relatedFallback) {
      rel = si.cards.filter((a) => a[6] > 0 && notMe(a)).map(tupleToItem).sort(byEraThenPrice);
    }
    railData.related = await withImages(rel, 10);
    railData.related.forEach((c) => shown.add(c.handle));

    /* rail 2 — même Pokémon */
    const me = si.cards.find((a) => a[0] === P.code && a[1] === P.n);
    const spKey = me && me[7];
    let same = spKey
      ? si.cards.filter((a) => a[7] === spKey && a[6] > 0 && notMe(a)).map(tupleToItem)
          .filter((c) => !shown.has(c.handle)).sort((x, y) => y.price - x.price)
      : [];
    railData.sameIsSpecies = same.length > 0;
    if (!same.length && !railData.relatedFallback) {
      same = si.cards.filter((a) => a[6] > 0 && notMe(a)).map(tupleToItem)
        .filter((c) => !shown.has(c.handle)).sort(byEraThenPrice);
    }
    railData.same = await withImages(same, 10);
  }
  /* Navigation des rails de la fiche : clic carte → page produit.
     (Manquait : seuls l'accueil et les pages collection avaient leur handler ;
     l'ajout panier reste géré par le délégué global de jcc-cart.js.) */
  document.addEventListener("click", (e) => {
    if (e.target.closest(".ccard__add")) return;
    const art = e.target.closest(".ccard--go");
    if (art && art.dataset.href) location.href = art.dataset.href;
  });

  function renderRails() {
    const relSec = document.querySelector(".pp-related");
    if (relSec) {
      if (!railData.related || !railData.related.length) relSec.hidden = true;
      else {
        relSec.hidden = false;
        const h2 = relSec.querySelector("h2");
        const chip = $("ppRelSet");
        const seeSet = $("ppSeeSet");
        if (railData.relatedFallback) {
          if (h2) { h2.removeAttribute("data-i18n"); h2.textContent = t("pp_also"); }
          if (chip) chip.hidden = true;
          if (seeSet) seeSet.hidden = true;
        } else {
          if (h2) { h2.setAttribute("data-i18n", "pp_related"); h2.textContent = t("pp_related"); }
          if (chip) chip.hidden = false;
          if (seeSet) seeSet.hidden = false;
        }
        $("ppRail").innerHTML = railData.related.map(railCard).join("");
      }
    }
    const sec = $("ppSamePoke");
    if (sec) {
      if (!railData.same || !railData.same.length) sec.hidden = true;
      else {
        const base = name().replace(/\s*(ex|gx|v(?:max|star)?|break|prime|legend|niv\.?\s*x|lv\.?\s*x|star|☆|δ)\b.*$/i, "").trim() || name();
        $("ppSameTitle").textContent = railData.sameIsSpecies
          ? t("pp_same_poke").replace("{name}", base) : t("pp_also");
        $("ppSameRail").innerHTML = railData.same.map(railCard).join("");
        sec.hidden = false;
      }
    }
  }
  function renderReviews() {
    if (!window.JCC || !window.JCC.data.reviews) return;
    fetch(window.JCC.data.reviews).then((r) => r.json()).then((rv) => {
      $("ppRevRail").innerHTML = (rv.cards || []).slice(0, 8).map((c) => {
        const txt = (lang() === "en" ? c.en : c.fr) || c.fr;
        return '<figure class="rev-card">' +
          '<div class="rev-card__stars" role="img" aria-label="5/5">' + RSTAR.repeat(5) + "</div>" +
          '<blockquote class="rev-card__quote">' + esc(txt) + "</blockquote>" +
          '<span class="rev-card__buy">' + esc(c.buy) + "</span>" +
          '<figcaption class="rev-card__who">' +
          '<img class="rev-card__avatar" src="' + window.JCC.base + "avatars-" + c.av + '.webp" alt="" loading="lazy" />' +
          "<span><b>" + esc(c.name) + "</b><i>" + t("verified") + "</i></span>" +
          "</figcaption></figure>";
      }).join("");
    }).catch(() => {});
  }

  /* ---------- interactions ---------- */
  function renderStars() {
    $("ppStars").innerHTML = RSTAR.repeat(5) + "<b>5/5</b><span>· +1 900 " + t("pp_rev_n") + "</span>";
    const ss = $("ppScoreStars");
    if (ss) ss.innerHTML = RSTAR.repeat(5);
  }
  /* Scans HD : beaucoup de webp importés sont des miniatures (~214px).
     Comme sur le prototype, on upgrade vers le scan PokéCardex HD quand il existe :
     - remplace l'image principale si elle affiche le scan (pas de photo réelle),
     - met à jour la 1re vignette de la galerie (le scan) pour le clic. */
  (function () {
    if (!P.code || !P.n || P.gradeNote) return;
    const scanEl = $("ppScan");
    if (!scanEl) return;
    const hd = new Image();
    hd.onload = function () {
      if (hd.naturalWidth < 400) return;
      /* avec la galerie slider, #ppScan est TOUJOURS l'image scan (slide 0) */
      scanEl.src = hd.src;
      const thumbs = document.querySelectorAll("#ppThumbs .pp-thumb");
      if (thumbs.length) {
        const ti = thumbs[0].querySelector("img");
        if (ti) ti.src = hd.src;
      }
    };
    hd.src = "https://pokecardex-scans.b-cdn.net/sets_jp/" + P.code + "/" + P.n + ".jpg";
  })();

  /* Lightbox : clic sur une photo → plein écran, zoom pinch / double-tap / pan,
     navigation ‹ › et swipe, fermeture fond / ✕ / Échap. */
  (function () {
    const gallery = $("ppGallery");
    const lb = $("ppLightbox");
    if (!gallery || !lb) return;
    const img = $("ppLbImg");
    const stage = $("ppLbStage");
    const count = $("ppLbCount");
    const srcs = [].slice.call(gallery.querySelectorAll(".pp-slide img"));
    /* ne parcourir que les photos de l'état affiché (slides non masquées par le filtre) */
    const visible = () => srcs.filter((s) => { const sl = s.closest(".pp-slide"); return !sl || !sl.hidden; });
    let list = srcs;
    let cur = 0, scale = 1, tx = 0, ty = 0;
    const apply = () => { img.style.transform = "translate(" + tx + "px," + ty + "px) scale(" + scale + ")"; };
    const reset = () => { scale = 1; tx = 0; ty = 0; apply(); };
    const clampPan = () => {
      scale = Math.min(4, Math.max(1, scale));
      const mx = (scale - 1) * stage.clientWidth / 2;
      const my = (scale - 1) * stage.clientHeight / 2;
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    };
    const show = (i) => {
      if (!list.length) return;
      cur = (i + list.length) % list.length;
      const el = list[cur];
      img.src = el.dataset.full || el.currentSrc || el.src;
      count.textContent = (cur + 1) + " / " + list.length;
      reset();
    };
    const open = (i) => { list = visible(); show(i); lb.hidden = false; document.body.style.overflow = "hidden"; };
    const close = () => { lb.hidden = true; document.body.style.overflow = ""; };
    gallery.addEventListener("click", (e) => {
      const im = e.target.closest(".pp-slide img");
      if (im) open(visible().indexOf(im));
    });
    lb.querySelector(".pp-lightbox__close").addEventListener("click", close);
    lb.addEventListener("click", (e) => { if (e.target === lb || e.target === stage) close(); });
    lb.querySelector(".pp-lightbox__prev").addEventListener("click", () => show(cur - 1));
    lb.querySelector(".pp-lightbox__next").addEventListener("click", () => show(cur + 1));
    document.addEventListener("keydown", (e) => {
      if (lb.hidden) return;
      if (e.key === "Escape") close();
      else if (e.key === "ArrowLeft") show(cur - 1);
      else if (e.key === "ArrowRight") show(cur + 1);
    });
    /* Gestes photo : pinch autour du point médian des doigts (focal),
       double-tap vers le point touché, pan un doigt, re-base quand un doigt se lève. */
    const pts = new Map();
    let sScale = 1, sTx = 0, sTy = 0, sDist = 1, sQ = null, sPos = null;
    let moved = false, lastTap = 0, lastTapPos = null;
    const relPt = (x, y) => {
      const r = stage.getBoundingClientRect();
      return { x: x - (r.left + r.width / 2), y: y - (r.top + r.height / 2) };
    };
    const clampT = () => {
      scale = Math.min(4, Math.max(1, scale));
      const mx = Math.max(0, (scale - 1) * stage.clientWidth / 2);
      const my = Math.max(0, (scale - 1) * stage.clientHeight / 2);
      tx = Math.min(mx, Math.max(-mx, tx));
      ty = Math.min(my, Math.max(-my, ty));
    };
    const applySmooth = () => {
      img.style.transition = "transform .22s ease";
      apply();
      setTimeout(() => { img.style.transition = "none"; }, 240);
    };
    const beginGesture = () => {
      sScale = scale; sTx = tx; sTy = ty;
      const v = [...pts.values()];
      if (v.length === 2) {
        sDist = Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y) || 1;
        const m = relPt((v[0].x + v[1].x) / 2, (v[0].y + v[1].y) / 2);
        sQ = { x: (m.x - sTx) / sScale, y: (m.y - sTy) / sScale };
      } else if (v.length === 1) {
        sPos = { x: v[0].x, y: v[0].y };
      }
    };
    img.addEventListener("pointerdown", (e) => {
      e.preventDefault();
      try { img.setPointerCapture(e.pointerId); } catch (err) {}
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      moved = false;
      beginGesture();
    });
    img.addEventListener("pointermove", (e) => {
      if (!pts.has(e.pointerId)) return;
      pts.set(e.pointerId, { x: e.clientX, y: e.clientY });
      const v = [...pts.values()];
      if (v.length === 2) {
        const d = Math.hypot(v[0].x - v[1].x, v[0].y - v[1].y) || 1;
        const m = relPt((v[0].x + v[1].x) / 2, (v[0].y + v[1].y) / 2);
        scale = sScale * (d / sDist);
        scale = Math.min(4, Math.max(1, scale));
        tx = m.x - sQ.x * scale;
        ty = m.y - sQ.y * scale;
        clampT(); apply(); moved = true;
      } else if (v.length === 1 && sPos) {
        const dx = e.clientX - sPos.x, dy = e.clientY - sPos.y;
        if (Math.abs(dx) > 4 || Math.abs(dy) > 4) moved = true;
        if (scale > 1) { tx = sTx + dx; ty = sTy + dy; clampT(); apply(); }
      }
    });
    const up = (e) => {
      if (!pts.has(e.pointerId)) return;
      pts.delete(e.pointerId);
      if (pts.size) { beginGesture(); return; }
      if (!moved) {
        const now = Date.now();
        const near = lastTapPos && Math.hypot(e.clientX - lastTapPos.x, e.clientY - lastTapPos.y) < 44;
        if (now - lastTap < 320 && near) {
          if (scale > 1) { scale = 1; tx = 0; ty = 0; applySmooth(); }
          else {
            const pPt = relPt(e.clientX, e.clientY);
            const q = { x: (pPt.x - tx) / scale, y: (pPt.y - ty) / scale };
            scale = 2.5;
            tx = pPt.x - q.x * scale;
            ty = pPt.y - q.y * scale;
            clampT(); applySmooth();
          }
          lastTap = 0; lastTapPos = null;
        } else { lastTap = now; lastTapPos = { x: e.clientX, y: e.clientY }; }
      } else if (scale === 1 && sPos) {
        const dx = e.clientX - sPos.x;
        if (Math.abs(dx) > 60) show(cur + (dx < 0 ? 1 : -1));
      }
    };
    img.addEventListener("pointerup", up);
    img.addEventListener("pointercancel", up);
  })();

  /* Galerie glissable : slides scroll-snap, vignettes synchronisées dans les 2 sens */
  (function () {
    const gallery = $("ppGallery");
    if (!gallery) return;
    const slides = [].slice.call(gallery.querySelectorAll(".pp-slide"));
    const thumbsBox = $("ppThumbs");
    const thumbs = thumbsBox ? [].slice.call(thumbsBox.querySelectorAll(".pp-thumb")) : [];
    const goTo = (i, smooth) => {
      const sl = slides[i];
      if (sl) gallery.scrollTo({ left: sl.offsetLeft, behavior: smooth ? "smooth" : "instant" });
    };
    thumbs.forEach((b, i) => b.addEventListener("click", () => goTo(i, true)));
    let raf = null;
    gallery.addEventListener("scroll", () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        const step = slides.length > 1 ? Math.max(1, slides[1].offsetLeft - slides[0].offsetLeft) : gallery.clientWidth;
        const idx = Math.max(0, Math.min(slides.length - 1, Math.round(gallery.scrollLeft / step)));
        thumbs.forEach((b, i) => b.classList.toggle("is-active", i === idx));
        if (thumbs[idx]) thumbs[idx].scrollIntoView({ block: "nearest", inline: "nearest" });
      });
    }, { passive: true });
    /* Filtre par état : chaque photo porte data-cond (— NM / — EX / — scan). En sélectionnant
       un état, on n'affiche que ses photos (le scan reste visible). Si la carte n'a pas de photo
       propre à cet état, on montre tout (repli — pas de photo cachée à tort). */
    ppFilter = function (cond) {
      const c = (cond || "").toLowerCase();
      const has = slides.some((s) => (s.getAttribute("data-cond") || "") === c);
      const keep = (dc) => !has || dc === "" || dc === "scan" || dc === c;
      slides.forEach((s) => { s.hidden = !keep(s.getAttribute("data-cond") || ""); });
      thumbs.forEach((t) => { t.hidden = !keep(t.getAttribute("data-cond") || ""); });
      const real = slides.find((s) => !s.hidden && (s.getAttribute("data-cond") || "") !== "scan");
      const target = real || slides.find((s) => !s.hidden);
      if (target) gallery.scrollTo({ left: target.offsetLeft, behavior: "instant" });
    };
    /* État initial. Le filtre est appliqué TOUT DE SUITE, pas dans un requestAnimationFrame :
       dans un onglet ouvert en arrière-plan (clic milieu depuis une liste, cas courant) le rAF
       ne se déclenche qu'à la première mise au premier plan — la galerie affichait d'ici là les
       photos de TOUS les états mélangées. Le rAF ne sert plus qu'à recaler le scroll une fois la
       mise en page connue (offsetLeft vaut 0 tant que rien n'est peint). */
    ppFilter(condOf(sel));
    requestAnimationFrame(() => ppFilter(condOf(sel)));
  })();
  $("qtyMinus").addEventListener("click", () => { qty = Math.max(1, qty - 1); renderPriceStock(); });
  $("qtyPlus").addEventListener("click", () => { qty = Math.min(Math.max(1, sel.qty), qty + 1); renderPriceStock(); });
  $("qtyInput").addEventListener("change", () => {
    qty = Math.max(1, Math.min(Math.max(1, sel.qty), parseInt($("qtyInput").value, 10) || 1));
    renderPriceStock();
  });
  function doAdd() {
    if ($("ppAdd").disabled) return;
    const btns = [$("ppAdd"), $("ppStickyAdd")].filter(Boolean);
    btns.forEach((b) => { b.disabled = true; });
    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: sel.id, quantity: qty }),
    }).then((r) => {
      if (!r.ok) throw 0;
      return fetch("/cart.js").then((x) => x.json());
    }).then((cart) => {
      const counter = document.querySelector(".cart__count");
      if (counter) {
        counter.textContent = cart.item_count;
        counter.hidden = !cart.item_count;
        counter.animate([{ transform: "scale(1)" }, { transform: "scale(1.5)" }, { transform: "scale(1)" }],
          { duration: 320, easing: "ease-out" });
      }
      if (window.JCC_CART) window.JCC_CART.refresh(cart, true);
      btns.forEach((b) => {
        const label = b.querySelector("[data-i18n]") || b;
        b.dataset.oldLabel = label.textContent;
        label.textContent = t("pp_added");
        b.classList.add("is-added");
      });
      setTimeout(() => {
        btns.forEach((b) => {
          const label = b.querySelector("[data-i18n]") || b;
          label.textContent = b.dataset.oldLabel;
          b.classList.remove("is-added");
          b.disabled = false;
        });
        renderPriceStock();
      }, 1200);
    }).catch(() => {
      btns.forEach((b) => { b.disabled = false; });
      alert(lang() === "en" ? "Unable to add to cart — please retry." : "Impossible d'ajouter au panier — réessayez.");
    });
  }
  $("ppAdd").addEventListener("click", doAdd);
  if ($("ppStickyAdd")) $("ppStickyAdd").addEventListener("click", doAdd);

  /* Barre sticky bas d'écran : visible quand le bloc achat principal est hors
     viewport et que la carte est en stock. */
  (function () {
    const bar = $("ppSticky");
    const target = $("ppActions");
    if (!bar || !target || !("IntersectionObserver" in window)) return;
    let mainVisible = true;
    const sync = () => {
      const on = !mainVisible && totalStock() > 0 && sel.qty > 0;
      bar.classList.toggle("is-on", on);
      bar.setAttribute("aria-hidden", on ? "false" : "true");
    };
    new IntersectionObserver((entries) => {
      entries.forEach((e) => { mainVisible = e.isIntersecting; });
      sync();
    }, { threshold: 0 }).observe(target);
    window.JCC_SYNC_STICKY = sync;
  })();
  $("ppGuideBtn").addEventListener("click", () => {
    $("ppGuide").scrollIntoView({ behavior: "smooth", block: "start" });
  });
  $("ppNotify").addEventListener("submit", (e) => {
    e.preventDefault();
    $("ppNotifyOk").hidden = false;
    e.target.querySelector("input").value = "";
  });

  function renderAll() {
    renderStars(); renderPriceStock(); renderConds(); renderDescSpecs(); renderGuide(); renderRails();
  }
  renderAll();
  buildRails().then(renderRails);
  renderReviews();

  new MutationObserver(() => { renderAll(); renderReviews(); })
    .observe(document.documentElement, { attributes: true, attributeFilter: ["lang"] });
})();
